import React, { useState, useRef, useEffect } from "react";
import { IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/MegaMenu";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "owl.carousel"; // Import Owl Carousel AFTER jQuery
import OwlCarousel from "react-owl-carousel";
import '../outterpages.css'
import curreciesBan from '../../../assets/Images/Outterpage/currencies-banner-img.webp';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from "@mui/material/styles";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Stack from '@mui/material/Stack';
import eng from '../../../assets/Images/Outterpage/eng.webp'
import jap from '../../../assets/Images/Outterpage/jap.webp'
import cardimg from '../../../assets/Images/Outterpage/card-1.webp'
import sec4 from '../../../assets/Images/Outterpage/sec-4-img.webp'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "1px solid  rgba(255, 146, 71, 1)  ",
    '&:nth-of-type(odd)': {
        background: "linear-gradient(90deg,rgba(99, 97, 97, 0.44) 15.1%,rgba(70, 69, 68, 0.49) 85.42%)",
    },
    // Hide the last border of the table
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

// const videos = [
//   { id: 1, src: video1 },
//   { id: 2, src: video2 },
//   { id: 3, src: video3 },
//   { id: 3, src: video4 },
// ];
const testimonials = [
    {
        name: "Sherly",
        position: "CEO",
        text: "Figma ipsum component variant main layer. Library figjam subtract font rotate move auto. Figjam strikethrough bullet text device pen scale. Group horizontal link library flows ellipse flatten library undo.",
    },
    {
        name: "Carlos",
        position: "Product Manager",
        text: "An amazing experience! The support and innovation mindset Rishi brings to the team makes every project more exciting and successful.",
    },
    // {
    //   name: "Rishi",
    //   position: "CEO",
    //   text: "Regulus has truly streamlined my trading activity. The platform is incredibly user-friendly, making it easy to navigate and execute trades quickly. I've seen a noticeable improvement in my efficiency!",
    // },
];

const options = {
    margin: 50,
    items: 1,
    autoplay: true,
    autoplayTimeout: 6000,
    dots: false, // Hide default dots
    loop: true,
    smartSpeed: 800,
    nav: true, // We will use custom navigation
    responsive: {
        0: {
            dots: true,
            nav: false,
        },
        768: {
            dots: false,
            nav: true,
        },
    },
};

const marketData = [
    { id: 1, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 2, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 3, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 4, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 5, pair: "GBP/USD", value: "1,120.65", trend: "down" },
];


const tableData = [
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },

]
const accordianData = [
    {
        question: "What is Finowiz ?",
        answer: "Founded in 2016, Finowiz provides a comprehensive trading environment for Contracts for Difference (CFDs), covering FX currency pairs, stock indexes, metals, and energy. Our clients can trade these CFD products using MetaTrader 4, MetaTrader 5, or via Web Trader. As a global retail brokerage, Finowiz is committed to offering top-tier services to traders worldwide.",
        panel: "panel1"
    },
    {
        question: "Is it mandatory to register my card before making a deposit?",
        answer: "Yes, it is. To enable credit card deposits, you must pre-register your card with Shufti, our automated authentication system, available in the Client Cabinet. If automatic authentication is not possible due to the absence of a camera, you can alternatively send a selfie holding your credit card and ID to our support team via email.",
        panel: "panel2"
    },
    {
        question: "I have invalidated/updated the credit cards utilized for deposits. How can I retrieve the funds?",
        answer: "Even if you have invalidated or renewed the credit/debit card used for a deposit, you can still withdraw funds to the original card. This process depends on the information maintained by the card company. However, specific details may vary, so it is advisable to verify with your card company.",
        panel: "panel3"
    },
    {
        question: "I am unable to transfer funds between accounts.",
        answer: "Fund transfers might be restricted if you have ongoing positions, especially if the transfer amount is equal to or exceeds 90% of your effective margin. Please review the transfer amount and try again",
        panel: "panel4"
    },
    {
        question: "Can I utilize my demo account indefinitely?",
        answer: "Clients with a live account can maintain up to 3 demo accounts without an expiration date. If you wish to set up a demo account with no defined expiry, please contact us with your specific details.",
        panel: "panel5"
    },
    {
        question: "I am encountering difficulties depositing with a credit (debit) card.",
        answer: "Several factors could be causing this issue, such as limitations related to the card type, input errors, browser compatibility, or restrictions set by the card company. Please check your card's status and, if needed, contact your card company to resolve any restrictions.",
        panel: "panel6"
    }
    ,
    {
        question: "Will there be a fee for credit card withdrawals?",
        answer: "No, there are no fees for deposits or withdrawals made with a credit or debit card. For details on fees associated with alternative withdrawal methods, please refer to the provided information",
        panel: "panel7"
    }
    ,
    {
        question: "How does debit card withdrawal differ from credit card refund processing?",
        answer: "While refund procedures are similar for credit and debit cards, there are key differences. Debit card transactions result in immediate deductions from your account. Refunds to debit cards are directly credited back to your bank account.",
        panel: "panel8"
    }
    ,
    {
        question: "Introducing Broker (IB) Program",
        answer: "If you're interested in joining our Introducing Broker (IB) program, please complete our form. For any inquiries about the IB program, contact our partner team at support@finowiz.com.",
        panel: "panel9"
    }
    ,

]

const Currencies = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const md900 = useMediaQuery(theme.breakpoints.up("900"));
    const xl = useMediaQuery(theme.breakpoints.up("xl"));
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    return (
        <div className="OutterPage">
            <Header />
            <div className="bg-outer">
                <section className="banner outter-banner">
                    <div className="contain-width">
                        <Grid container sx={{ alignItems: "flexStart" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} sx={{ placeContent: "center" }}>
                                <div
                                    className="banner-left "
                                    style={{ height: xl ? "500px" : "auto", placeContent: "center" }}
                                >
                                    <p>Trade Currencies on the global Financial Markets</p>
                                    <h1 className="mb-30 mt-10">
                                        Experience Superior Online <span>Forex Trading</span> with Finowiz
                                    </h1>
                                    <p>Forex trading, also known as foreign exchange trading, involves exchanging one currency for another in the global market. At Finowiz, traders can take advantage of market fluctuations by purchasing currencies at lower prices and selling them at higher prices to maximize their profits.</p>
                                    {/* <div
                  className="display-1 btn flex-wrap "
                  style={{ marginBottom: matches ? "40px" : "20px" }}
                >
                  <Link to="/open-new-account" className="bg-btn">
                    Get Started
                  </Link>
                </div> */}
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                                <div className="text-center ban-img">
                                    <img width="90%" src={curreciesBan} />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </section>
              
                <section className="trade-easy sec-3">
                    <div className="contain-width">
                        <div className="heading">
                            <p>
                                <span>Why Finowiz</span>
                            </p>
                            <h2>
                                Why Choose <span>Finowiz</span> for Forex Trading?
                            </h2>
                            {/* <p>
                                Figma ipsum component variant main layer. Prototype share asset stroke distribute star create. Rectangle stroke auto figjam project library select.
                            </p> */}
                        </div>
                        <Grid container spacing={5} >
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                <div>
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd">Spreads from 0 Pips</span></p>
                                <p className="mt-10">Benefit from competitive spreads starting from 0 pips, providing cost-effective trading opportunities with Finowiz.</p>

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                <div>
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd">Leverage up to 1:1000</span></p>
                                <p className="mt-10">Trade with leverage up to 1:1000 across all account types, enhancing your trading potential with Finowiz.</p>

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                <div >
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd" >High Execution Speed</span></p>
                                <p className="mt-10">Experience rapid order execution, typically within 0.1 seconds, ensuring your trades are efficient and timely with Finowiz.</p>

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                <div>
                                    <img src={cardimg} />
                                </div>
                                <p className="mt-10 head"><span className="grd">60+ Currency Pairs</span></p>
                                <p className="mt-10">Gain access to over 60 currency pairs, including popular options such as EUR/USD, USD/JPY, GBP/USD, and EUR/GBP, offering diverse trading possibilities with Finowiz.</p>

                            </Grid>

                        </Grid>


                    </div>
                </section>
            </div>
            <section className="trade-open section-4">
                <div className="contain-width">
                    <Grid container spacing={8} sx={{ rowGap: 0 }}>
                        <Grid
                            item
                            size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                            className="left-side"
                        >
                            <h3>
                                Trade Top Currencies with <span>Finowiz</span>
                            </h3>
                            <p>
                            Explore and trade the leading currency pairs in the forex market with Finowiz. Take advantage of competitive spreads, high liquidity, and an array of trading tools to enhance your forex trading experience.
                            </p>
                            <div className="mt-40">
                                <Link to="#" className="bg-btn">
                                    Register now
                                </Link>
                            </div>
                        </Grid>
                        <Grid
                            item
                            size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                            className=""
                        >
                            <div>
                                <img width="100%" src={sec4} />
                            </div>

                        </Grid>
                    </Grid>
                </div>
            </section>
   
            <section class="cta-sec2 out-cta">
                <div className="contain-width">
                    <Grid container spacing={8}>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <label>Your Partner in Trading Success</label>
                            <h2 >Register Now for Seamless Trading with Finowiz</h2>
                            {/* <p>
                            Learn to trade without using real money, refining your
                            strategies and learning from mistakes.
                          </p> */}
                            <Link to="#" className="brd-btn" >
                                Register Now
                            </Link>
                        </Grid>
                    </Grid>
                </div>
            </section>


            <Footer />
        </div>
    );
};

export default Currencies;
